import Vue from 'vue';
import '@/registerServiceWorker';

// Router
import router from '@/bootstrap/router';

// Bootstrap
import '@/bootstrap/logging';
import '@/bootstrap/axios';
import '@/bootstrap/store';
import '@/bootstrap/config';
import '@/bootstrap/events';
import '@/bootstrap/localization';
import '@/bootstrap/datetime';
import '@/bootstrap/components';
import '@/bootstrap/filters';
import '@/bootstrap/directives';
import '@/bootstrap/mixins';
import '@/bootstrap/auth';
// import '@/bootstrap/toasted';
import '@/bootstrap/validation';

// Store
import store from '@/store';

// Application
import App from '@/views/App.vue';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
